import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      toast.success(`Bem-vindo, ${data.name || data.email}!`);
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-4 py-16">
      <h1 className="font-heading font-black text-3xl text-brand-text">Entrar</h1>
      <p className="mt-2 text-brand-textMuted">Acesse sua conta para cadastrar lugares e avaliar.</p>

      <button
        data-testid="google-login-btn"
        onClick={googleLogin}
        className="mt-8 w-full rounded-full border-2 border-brand-border bg-white py-3 font-bold text-brand-text hover:border-brand-primary transition-colors flex items-center justify-center gap-3"
      >
        <svg width="20" height="20" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3l5.7-5.7C34 5.1 29.3 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21 21-9.4 21-21c0-1.2-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.9 1.2 8 3l5.7-5.7C34 5.1 29.3 3 24 3 16.3 3 9.7 7.4 6.3 14.7z"/><path fill="#4CAF50" d="M24 45c5.2 0 10-1.9 13.6-5l-6.3-5.3C29.4 36.1 26.8 37 24 37c-5.2 0-9.7-3.3-11.3-8l-6.5 5C9.5 40.5 16.2 45 24 45z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2-2.1 3.7-3.9 4.9l6.3 5.3c-.4.4 6.6-4.8 6.6-14.2 0-1.2-.1-2.3-.4-3.5z"/></svg>
        Continuar com Google
      </button>

      <div className="my-6 flex items-center gap-3 text-xs uppercase tracking-wider text-brand-textMuted">
        <span className="flex-1 h-px bg-brand-border" /> ou e-mail <span className="flex-1 h-px bg-brand-border" />
      </div>

      <form onSubmit={submit} className="space-y-4">
        <Input data-testid="email-input" required type="email" placeholder="E-mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-brand-bg border-brand-border rounded-2xl h-12" />
        <Input data-testid="password-input" required type="password" placeholder="Senha" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="bg-brand-bg border-brand-border rounded-2xl h-12" />
        <Button data-testid="login-submit-btn" disabled={loading} className="w-full bg-brand-primary hover:bg-brand-primaryHover text-white rounded-full font-bold py-6">
          {loading ? "Entrando..." : "Entrar"}
        </Button>
      </form>

      <p className="mt-6 text-sm text-brand-textMuted text-center">
        Não tem conta? <Link to="/registrar" className="text-brand-primary font-bold hover:underline">Criar conta</Link>
      </p>
    </div>
  );
}
